module.exports = __webpack_public_path__ + "img/hr.63b2b01d.svg";